import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import PhoneNumber from '../../../../PhoneNumber/PhoneNumber';
import styles from './ContractorInfo.module.scss';

const ContractorInfo = ({ warrantyInfo = {} }) => {
  const name = warrantyInfo.organization?.name || undefined;

  const startDate = warrantyInfo.startDate
    ? `${moment(warrantyInfo.startDate).format('DD.MM.YYYY')}`
    : undefined;

  const endDate = warrantyInfo.endDate
    ? `${moment(warrantyInfo.endDate).format('DD.MM.YYYY')}`
    : undefined;

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        {name && (
          <p className={cn(styles.text, styles.name)}>
            {warrantyInfo.organization?.name || ''}
          </p>
        )}

        {startDate && endDate && (
          <p className={cn(styles.text, styles.date)}>
            {`${startDate} — ${endDate}`}
          </p>
        )}
      </div>
      <div className={styles.wrap} style={{ alignItems: 'flex-end' }}>
        {warrantyInfo.contactPhone && (
          <PhoneNumber
            className={cn(styles.text, styles.phone)}
            phoneNumber={warrantyInfo.contactPhone}
            name={warrantyInfo.contactName}
          />
        )}
        {warrantyInfo.contactName && (
          <span className={cn(styles.text, styles.phone)}>
            {warrantyInfo.contactName}
          </span>
        )}
      </div>
    </div>
  );
};

export default ContractorInfo;
